import request from '@/axios'

export const loginApi = (data: LoginReqVo): Promise<IResponse<AuthLoginRespVO>> => {
  return request.post({ url: '/client/auth/login', data })
}

export const loginOutApi = (): Promise<IResponse<boolean>> => {
  return request.post({ url: '/client/auth/logout' })
}

export enum LoginTypeEnum {
  ACCOUNT_PASSWORD = 'ACCOUNT_PASSWORD'
}

export enum UserInfoTypeEnum {
  /** 系统内置用户 */
  DEFAULT = 1,
  /** 租户超级管理员 */
  TENANT_SUPER_ADMIN = 2,
  /** 租户员工，由机构用户创建 */
  TENANT_STAFF = 3
}

export interface LoginReqVo {
  type: LoginTypeEnum
  account: string
  password: string
}

export interface AuthLoginRespVO {
  accountCode: string
  tokenType: string
  token: string
  expiresTime: number
}

export interface LoginInfo {
  account: string
  password: string
}

export interface UserInfo {
  code: string
  name: string
  type: number
  avatar?: string
}
